import type { OptionsSourceValueRes } from '@n3oltd/karakoram.digital.sdk.options-sources'

export interface PickerOption {
  value: string
  label: string
}

export interface OptionsQuery {
  source: string
  group: string | null
  searchText: string | null
}

export type FetchPickerOptions = (
  query: OptionsQuery,
  signal: AbortSignal,
) => Promise<PickerOption[]>


export function projectOptions(raw: ReadonlyArray<OptionsSourceValueRes>): PickerOption[] {
  const out: PickerOption[] = []
  for (const opt of raw) {
    if (typeof opt.value !== 'string' || opt.value === '') continue
    if (typeof opt.label !== 'string' || opt.label === '') continue
    out.push({ value: opt.value, label: opt.label })
  }
  return out
}
